<template>
    <div class="accordion" :id="`accordion-${data.id}`">
        <div class="card">
            <div class="card-header" :id="`heading-${data.id}`" style="background-color: white; border-bottom: 0px;" :style="`padding-left: ${newOffset}px;`">
                <h2 class="mb-0">
                    <button class="btn btn-block text-left" type="button" data-toggle="collapse" aria-expanded="true" @click="chooseFilter(data.id)">
                        <div class="flex">
                            <div class="w-3/4 selected-filter">
                                <span :id="`filter-text-${data.id}`">{{ name }}</span>
                            </div>
                            <div class="w-1/4" v-if="data.children != null" @click="clickFilter(data.id)">
                                <i class="fas" :class="{ 'fa-chevron-left': !chevronOpened, 'fa-chevron-down': chevronOpened }"></i>
                            </div>
                        </div>
                    </button>
                </h2>
            </div>
            
            <div v-if="data.children != null" :id="`collapse-${data.id}`" class="collapse" :aria-labelledby="`heading-${data.id}`" :data-parent="`#accordion-${data.id}`">
                <calendar-filter v-for="(child, name) in data.children" v-bind:key="child.id" :data="child" :name="name" :offset="newOffset" v-on:change-filter="changeFilter"></calendar-filter>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            data: Object,
            name: String,
            offset: Number,
            chevron: Boolean,
            selectedFilter: Number,
        },
        data: function () {
            return {
                newOffset: this.offset,
                chevronOpened: this.chevron,
                clickOpen: false,
            }
        },
        beforeMount() {
            this.newOffset += 30;
        },
        methods: {
            /**
             * 
             * Events
             * 
             */
            clickFilter(id) {
                this.clickOpen = true;
                this.chevronOpened = !this.chevronOpened;
                $(`#collapse-${id}`).collapse('toggle');
                $(`#filter-text-${id}`).toggleClass('font-weight-bold');
            },
            chooseFilter(filterID) {
                if (!this.clickOpen) {
                    this.$emit('change-filter', filterID);
                }

                this.clickOpen = false;
            },
            changeFilter(filterID) {
                this.$emit('change-filter', filterID);
            },
        },
    }
</script>
